export const SHOPPING_ACCESS_TOKEN = 'Shopping-Access-Token'
export const USER_INFO = 'Login_Userinfo'
export const USER_NAME = 'Login_Username'
export const SALEMAN_INFO = 'Login_Salemanname'
